var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-placeholder font-weight-light",style:(`
    width: ${_vm.width};
    height: ${_vm.height};
    z-index: ${_vm.z_index};
    left: ${_vm.sticky_left};
    border-color: ${_vm.border_color?`${_vm.border_color}`:'var(--header_border_color)'};
    background-color: ${_vm.background_color?`${_vm.background_color}`:'var(--v-color-4-base)'};
    ${_vm.max_height?`max-height: ${_vm.max_height};`:''}
    ${_vm.border_width?`border-width: ${_vm.border_width};`:''}
    ${_vm.min_width?`min-width: ${_vm.min_width};`:''}
    `)},[_vm._t("default"),_c('div',{staticClass:"header-placeholder-right-middle"},[_vm._t("right-middle")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }